interface BloodLabsIconProps {
  className?: string;
  width?: number;
  height?: number;
}

/** Test-tube glyph. Ported from Figma node 2:2978 (Advanced Blood tests
 *  package tab). Single path, uses currentColor for fill. */
export function BloodLabsIcon({
  className,
  width = 17.5337,
  height = 20.0385,
}: BloodLabsIconProps) {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 17.5337 20.0385"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M8.76683 18.0348C7.67023 18.0348 6.73576 17.6545 5.96343 16.894C5.19124 16.1337 4.80515 15.2105 4.80515 14.1243V6.49851C4.37688 6.49851 4.0117 6.34945 3.7096 6.05133C3.40737 5.75336 3.25625 5.39126 3.25625 4.96504V3.54547C3.25625 3.11925 3.40737 2.75581 3.7096 2.45516C4.0117 2.15438 4.37688 2.00398 4.80515 2.00398H12.7205C13.1486 2.00398 13.5151 2.15438 13.82 2.45516C14.125 2.75581 14.2774 3.11925 14.2774 3.54547V4.96504C14.2774 5.39126 14.125 5.75336 13.82 6.05133C13.5151 6.34945 13.1486 6.49851 12.7205 6.49851V14.246C12.6878 15.305 12.2881 16.2013 11.5213 16.9348C10.7545 17.6681 9.83631 18.0348 8.76683 18.0348ZM4.80515 5.23292H12.7205C12.7965 5.23292 12.863 5.20718 12.9201 5.15572C12.9772 5.10439 13.0057 5.04083 13.0057 4.96504V3.54547C13.0057 3.46967 12.9772 3.40478 12.9201 3.35078C12.863 3.29664 12.7965 3.26957 12.7205 3.26957H4.80515C4.72899 3.26957 4.66378 3.29664 4.60952 3.35078C4.55512 3.40478 4.52792 3.46967 4.52792 3.54547V4.96504C4.52792 5.04083 4.55512 5.10439 4.60952 5.15572C4.66378 5.20718 4.72899 5.23292 4.80515 5.23292ZM10.6663 16.0024C11.188 15.4914 11.4488 14.8654 11.4488 14.1243V13.8079H8.82384V12.5425H11.4488V10.498H8.82384V9.23239H11.4488V6.49851H6.07682V14.1243C6.07682 14.8654 6.339 15.4914 6.86335 16.0024C7.38784 16.5136 8.02234 16.7692 8.76683 16.7692C9.51132 16.7692 10.1445 16.5136 10.6663 16.0024Z"
        fill="currentColor"
      />
    </svg>
  );
}
